import script from "./PdNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./PdNotice.vue?vue&type=script&setup=true&lang=js"

import "./PdNotice.vue?vue&type=style&index=0&id=285b5323&scoped=true&lang=css"

import exportComponent from "../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285b5323"]])

export default __exports__